import type { IPageResponse } from "@/services";

export const mockPageResponse = <T>(content: T[]): IPageResponse<T> => ({
  content,
  pageable: {
    sort: {
      sorted: true,
      unsorted: false,
      empty: false,
    },
    pageNumber: 0,
    pageSize: 10,
    offset: 0,
    unpaged: false,
    paged: true,
  },
  last: false,
  totalElements: content.length,
  totalPages: 1,
  sort: {
    sorted: true,
    unsorted: false,
    empty: false,
  },
  number: 0,
  numberOfElements: 10,
  first: true,
  size: 10,
  empty: false,
});

// Re-exports para acceder a mock*Service desde "./backend"
export * from "./adapter";
export * from "./channel";
export * from "./client";
export * from "./country";
export * from "./currency";
export * from "./delegation";
export * from "./deposit";
export * from "./disclaimer";
export * from "./i18n";
export * from "./order_pending";
export * from "./report";
export * from "./servicepoint";
export * from "./sol";
export * from "./sol_customer";
export * from "./sol_service_api";
export * from "./subclient";
export * from "./user";
export * from "./usersguide";
export * from "./approvals";
